export const getScoreCardValue = (score: number) => {
  if (typeof score !== 'number') return 0
  return Math.round(score * 100)
}
